module.exports = __webpack_public_path__ + "img/holograms-2.dca43f7f.jpg";